import {useCategory as useCategorySDK} from '@salesforce/commerce-sdk-react'

/**
 * Custom hook to fetch category data using the Salesforce Commerce SDK.
 * This hook wraps the useCategorySDK from the commerce-sdk-react library.
 *
 * @param parameters - Parameters for the category query, typically including the category ID.
 * @param queryOptions - Optional query options to customize the behavior of the SDK call.
 * @returns An object containing the category data and other related properties.
 */
export const useCategory = (
    parameters: Parameters<typeof useCategorySDK>[0],
    queryOptions?: Parameters<typeof useCategorySDK>[1]
) => {
    const sdkResult = useCategorySDK(parameters, queryOptions)

    return {
        ...sdkResult
    }
}
